import service from '@/services/superaccess'

const home = {
  state: {
    data: false
  },
  actions: {
    retriveDataHome (context, payload) {
      return service.post('/api/home/all_data/', context, payload)
    }
  }
}

export default home



// WEBPACK FOOTER //
// app/javascript/src/store/home.js